import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { map, finalize } from 'rxjs/operators';
import { DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';
import { DynamicFormRuntimeComponent, FormDataService } from 'zr-dynamic-form/dynamic-form-runtime';

@Component({
  selector: 'df-dynamic-form-template-common',
  templateUrl: './dynamic-form-template-common.component.html',
  styleUrls: ['./dynamic-form-template-common.component.css']
})
export class DynamicFormTemplateCommonComponent implements OnInit {
  @Input() title: string = '';
  @Input() isAdd: boolean = true;
  @Input() dformReadOnly: boolean = false;
  showForm: boolean = false;

  formCode: string;
  labelCode: string;
  formName: string;

  saving: boolean = false;
  targetId: string;

  @ViewChild(`dynamicFormRuntime`) dynamicFormRuntime: DynamicFormRuntimeComponent;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formDataService: FormDataService,
    private commonConfig: DynamicFormCommonConfig
  ) {}

  ngOnInit() {
    this.route.parent.params.subscribe((params) => {
      this.formCode = params.formCode;
      this.labelCode = params.labelCode;
      this.formDataService.getFormName(this.formCode, this.labelCode).subscribe((s) => {
        this.formName = s;
        if (this.commonConfig.updateTitle && typeof this.commonConfig.updateTitle === 'function') {
          this.commonConfig.updateTitle(this.route.parent, this.formName);
        }
      });
    });

    if (!this.isAdd) {
      this.route.params.pipe(map((params) => params.id)).subscribe((id) => {
        this.targetId = id;
      });
    }
    this.showForm = true;
  }

  get dynamicFormValid(): boolean {
    if (!this.dynamicFormRuntime) {
      return false;
    }
    return this.dynamicFormRuntime.valid;
  }

  beforeLoad() {}

  afterLoad() {
    if (this.dynamicFormRuntime.loadErrorMsg) {
      this.commonConfig.log.error(this.dynamicFormRuntime.loadErrorMsg);
      return;
    }
  }

  beforeDataLoad() {}

  afterDataLoad() {}

  reset() {
    this.dynamicFormRuntime.clear();
  }

  update() {
    this.saving = true;
    this.dynamicFormRuntime
      .update(this.targetId)
      .pipe(
        finalize(() => {
          this.saving = false;
        })
      )
      .subscribe(
        (s) => {
          this.commonConfig.log.success(`${s}`);
          this.backToList();
        },
        (error) => {
          this.commonConfig.log.error(`${error}`);
        }
      );
  }

  submit() {
    this.saving = true;
    this.dynamicFormRuntime
      .add(undefined)
      .pipe(
        finalize(() => {
          this.saving = false;
        })
      )
      .subscribe(
        (s) => {
          this.commonConfig.log.success(`${s}`);
          this.backToList();
        },
        (error) => {
          this.commonConfig.log.error(`${error}`);
        }
      );
  }

  private backToList() {
    const params = this.isAdd ? '../' : '../../';
    this.router.navigate([params], { relativeTo: this.route });
  }
}
